import endpoints from "@/utils/constants";
import { apiHelper } from "@/utils/helpers";
const actions = {
  savePaymentMode(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.paymentModes}`,
          context.state.paymentMode
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getPaymentModes(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}${endpoints.API.paymentModes}`)
        .then(res => {
          const defaultPaymentMode = res.data.find(i => i.label === "Cash");

          // context.commit("sale/setDefaultPaymentMode",defaultPaymentMode.paymentModeId,{root:true})
          context.commit("setPaymentModes", res.data);
        });
    });
  },

  fetchPaymentMode(context, paymentModeId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.paymentModes}/${paymentModeId}`
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updatePaymentMode(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}${endpoints.API.paymentModes}/${context.state.paymentMode.paymentModeId}`,
          context.state.paymentMode
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setPaymentMode", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
export default actions;
